{
  "ods": {
    "core-colours": {
      "brand-light": {
        "50": {
          "$type": "color",
          "$value": "#fce6f1"
        },
        "100": {
          "$type": "color",
          "$value": "#f9cce3"
        },
        "200": {
          "$type": "color",
          "$value": "#f399c7"
        },
        "300": {
          "$type": "color",
          "$value": "#ee66ac"
        },
        "400": {
          "$type": "color",
          "$value": "#e83390"
        },
        "500": {
          "$type": "color",
          "$value": "{ods.core-colours.brand-light.magenta}"
        },
        "600": {
          "$type": "color",
          "$value": "#b5005d"
        },
        "700": {
          "$type": "color",
          "$value": "#880046"
        },
        "800": {
          "$type": "color",
          "$value": "#5a002e"
        },
        "900": {
          "$type": "color",
          "$value": "#2d0017"
        },
        "950": {
          "$type": "color",
          "$value": "#16000b"
        },
        "magenta": {
          "$type": "color",
          "$value": "#e20074"
        }
      },
      "base": {
        "black": {
          "$type": "color",
          "$value": "#000000"
        },
        "white": {
          "$type": "color",
          "$value": "#ffffff"
        },
        "black-40": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.4000)"
        },
        "white-40": {
          "$type": "color",
          "$value": "rgba(255, 255, 255, 0.4000)"
        }
      },
      "grey": {
        "100": {
          "$type": "color",
          "$value": "#f1f1f1"
        },
        "200": {
          "$type": "color",
          "$value": "#dddddd"
        },
        "300": {
          "$type": "color",
          "$value": "#cacaca"
        },
        "400": {
          "$type": "color",
          "$value": "#b6b6b6"
        },
        "500": {
          "$type": "color",
          "$value": "#a3a3a3"
        },
        "600": {
          "$type": "color",
          "$value": "#828282"
        },
        "700": {
          "$type": "color",
          "$value": "#616161"
        },
        "800": {
          "$type": "color",
          "$value": "#414141"
        },
        "900": {
          "$type": "color",
          "$value": "#202020"
        }
      },
      "functional": {
        "green": {
          "100": {
            "$type": "color",
            "$value": "#ccf0e1"
          },
          "200": {
            "$type": "color",
            "$value": "#27ffa0"
          },
          "300": {
            "$type": "color",
            "$value": "#1bd27f"
          },
          "400": {
            "$type": "color",
            "$value": "#00c26d"
          },
          "600": {
            "$type": "color",
            "$value": "#008f52"
          },
          "700": {
            "$type": "color",
            "$value": "#007845"
          },
          "800": {
            "$type": "color",
            "$value": "#006138"
          },
          "900": {
            "$type": "color",
            "$value": "#004829"
          }
        },
        "red": {
          "100": {
            "$type": "color",
            "$value": "#ffdddb"
          },
          "200": {
            "$type": "color",
            "$value": "#ffa099"
          },
          "300": {
            "$type": "color",
            "$value": "#ff7066"
          },
          "400": {
            "$type": "color",
            "$value": "#ff4133"
          },
          "600": {
            "$type": "color",
            "$value": "#ff1000"
          },
          "700": {
            "$type": "color",
            "$value": "#c20d00"
          },
          "800": {
            "$type": "color",
            "$value": "#970b00"
          },
          "900": {
            "$type": "color",
            "$value": "#660700"
          }
        },
        "blue": {
          "100": {
            "$type": "color",
            "$value": "#d3d7f9"
          },
          "200": {
            "$type": "color",
            "$value": "#7486ff"
          },
          "300": {
            "$type": "color",
            "$value": "#576ff3"
          },
          "400": {
            "$type": "color",
            "$value": "#3950ea"
          },
          "600": {
            "$type": "color",
            "$value": "#2238df"
          },
          "700": {
            "$type": "color",
            "$value": "#05169b"
          },
          "800": {
            "$type": "color",
            "$value": "#000e79"
          },
          "900": {
            "$type": "color",
            "$value": "#131f7b"
          }
        },
        "orange": {
          "100": {
            "$type": "color",
            "$value": "#ffddcc"
          },
          "200": {
            "$type": "color",
            "$value": "#ffbb99"
          },
          "300": {
            "$type": "color",
            "$value": "#ff8b52"
          },
          "400": {
            "$type": "color",
            "$value": "#ff691f"
          },
          "600": {
            "$type": "color",
            "$value": "#b63d00"
          },
          "700": {
            "$type": "color",
            "$value": "#993300"
          },
          "800": {
            "$type": "color",
            "$value": "#662200"
          },
          "900": {
            "$type": "color",
            "$value": "#331100"
          }
        }
      },
      "secondary": {
        "aperitif": {
          "100": {
            "$type": "color",
            "$value": "#ffeae5"
          },
          "200": {
            "$type": "color",
            "$value": "#ffd1c7"
          },
          "300": {
            "$type": "color",
            "$value": "#ffb7a8"
          },
          "400": {
            "$type": "color",
            "$value": "#ff9e8a"
          },
          "600": {
            "$type": "color",
            "$value": "#ce6854"
          },
          "700": {
            "$type": "color",
            "$value": "#9c4d3d"
          },
          "800": {
            "$type": "color",
            "$value": "#6b3125"
          },
          "900": {
            "$type": "color",
            "$value": "#39150e"
          },
          "aperitif": {
            "$type": "color",
            "$value": "#ff846b"
          }
        },
        "basketball": {
          "100": {
            "$type": "color",
            "$value": "#ffeee5"
          },
          "200": {
            "$type": "color",
            "$value": "#ffd8c4"
          },
          "300": {
            "$type": "color",
            "$value": "#ffc2a3"
          },
          "400": {
            "$type": "color",
            "$value": "#ffac82"
          },
          "600": {
            "$type": "color",
            "$value": "#cc774c"
          },
          "700": {
            "$type": "color",
            "$value": "#995736"
          },
          "800": {
            "$type": "color",
            "$value": "#653821"
          },
          "900": {
            "$type": "color",
            "$value": "#32180b"
          },
          "basketball": {
            "$type": "color",
            "$value": "#ff9661"
          }
        },
        "cheddar": {
          "100": {
            "$type": "color",
            "$value": "#ffeedb"
          },
          "200": {
            "$type": "color",
            "$value": "#ffdfbb"
          },
          "300": {
            "$type": "color",
            "$value": "#ffd09b"
          },
          "400": {
            "$type": "color",
            "$value": "#ffc17c"
          },
          "600": {
            "$type": "color",
            "$value": "#cc8d46"
          },
          "700": {
            "$type": "color",
            "$value": "#996831"
          },
          "800": {
            "$type": "color",
            "$value": "#65421c"
          },
          "900": {
            "$type": "color",
            "$value": "#321d06"
          },
          "cheddar": {
            "$type": "color",
            "$value": "#ffb25c"
          }
        },
        "dandelion": {
          "100": {
            "$type": "color",
            "$value": "#fcf1ca"
          },
          "200": {
            "$type": "color",
            "$value": "#fbe9a9"
          },
          "300": {
            "$type": "color",
            "$value": "#f9e188"
          },
          "400": {
            "$type": "color",
            "$value": "#f8d867"
          },
          "600": {
            "$type": "color",
            "$value": "#c2a436"
          },
          "700": {
            "$type": "color",
            "$value": "#8f7827"
          },
          "800": {
            "$type": "color",
            "$value": "#5b4c17"
          },
          "900": {
            "$type": "color",
            "$value": "#2f2604"
          },
          "dandelion": {
            "$type": "color",
            "$value": "#f6d046"
          }
        },
        "egg": {
          "100": {
            "$type": "color",
            "$value": "#faf4bd"
          },
          "200": {
            "$type": "color",
            "$value": "#f7ee9b"
          },
          "300": {
            "$type": "color",
            "$value": "#f4e879"
          },
          "400": {
            "$type": "color",
            "$value": "#f2e256"
          },
          "600": {
            "$type": "color",
            "$value": "#bfb029"
          },
          "700": {
            "$type": "color",
            "$value": "#90841e"
          },
          "800": {
            "$type": "color",
            "$value": "#605813"
          },
          "900": {
            "$type": "color",
            "$value": "#302c08"
          },
          "egg": {
            "$type": "color",
            "$value": "#efdc34"
          }
        },
        "frog": {
          "100": {
            "$type": "color",
            "$value": "#f4f7c5"
          },
          "200": {
            "$type": "color",
            "$value": "#ecf0a2"
          },
          "300": {
            "$type": "color",
            "$value": "#e4ea7f"
          },
          "400": {
            "$type": "color",
            "$value": "#dce35b"
          },
          "600": {
            "$type": "color",
            "$value": "#aab02c"
          },
          "700": {
            "$type": "color",
            "$value": "#7f8420"
          },
          "800": {
            "$type": "color",
            "$value": "#555714"
          },
          "900": {
            "$type": "color",
            "$value": "#2a2b08"
          },
          "frog": {
            "$type": "color",
            "$value": "#d4dc38"
          }
        },
        "guacamole": {
          "100": {
            "$type": "color",
            "$value": "#ebf7d9"
          },
          "200": {
            "$type": "color",
            "$value": "#daf1b9"
          },
          "300": {
            "$type": "color",
            "$value": "#c9eb99"
          },
          "400": {
            "$type": "color",
            "$value": "#b8e479"
          },
          "600": {
            "$type": "color",
            "$value": "#84b146"
          },
          "700": {
            "$type": "color",
            "$value": "#628332"
          },
          "800": {
            "$type": "color",
            "$value": "#3f561e"
          },
          "900": {
            "$type": "color",
            "$value": "#1c280b"
          },
          "guacamole": {
            "$type": "color",
            "$value": "#a7de59"
          }
        },
        "hummingbird": {
          "100": {
            "$type": "color",
            "$value": "#e4fbe7"
          },
          "200": {
            "$type": "color",
            "$value": "#c8f5ce"
          },
          "300": {
            "$type": "color",
            "$value": "#acefb4"
          },
          "400": {
            "$type": "color",
            "$value": "#90e89b"
          },
          "600": {
            "$type": "color",
            "$value": "#5ab465"
          },
          "700": {
            "$type": "color",
            "$value": "#418749"
          },
          "800": {
            "$type": "color",
            "$value": "#27592c"
          },
          "900": {
            "$type": "color",
            "$value": "#0d2b10"
          },
          "hummingbird": {
            "$type": "color",
            "$value": "#74e281"
          }
        },
        "iguana": {
          "100": {
            "$type": "color",
            "$value": "#e1faf1"
          },
          "200": {
            "$type": "color",
            "$value": "#bcf3e1"
          },
          "300": {
            "$type": "color",
            "$value": "#97edd0"
          },
          "400": {
            "$type": "color",
            "$value": "#72e7c0"
          },
          "600": {
            "$type": "color",
            "$value": "#3cb28b"
          },
          "700": {
            "$type": "color",
            "$value": "#2c8567"
          },
          "800": {
            "$type": "color",
            "$value": "#1b5743"
          },
          "900": {
            "$type": "color",
            "$value": "#0a291f"
          },
          "iguana": {
            "$type": "color",
            "$value": "#4de0af"
          }
        },
        "jacuzzi": {
          "100": {
            "$type": "color",
            "$value": "#e2f9f7"
          },
          "200": {
            "$type": "color",
            "$value": "#bcf1ed"
          },
          "300": {
            "$type": "color",
            "$value": "#96e9e2"
          },
          "400": {
            "$type": "color",
            "$value": "#70e1d8"
          },
          "600": {
            "$type": "color",
            "$value": "#3aada3"
          },
          "700": {
            "$type": "color",
            "$value": "#2b8179"
          },
          "800": {
            "$type": "color",
            "$value": "#1b544f"
          },
          "900": {
            "$type": "color",
            "$value": "#0b2825"
          },
          "jacuzzi": {
            "$type": "color",
            "$value": "#4ad9cd"
          }
        },
        "kingfisher": {
          "100": {
            "$type": "color",
            "$value": "#e1f7fa"
          },
          "200": {
            "$type": "color",
            "$value": "#bceef3"
          },
          "300": {
            "$type": "color",
            "$value": "#97e4ed"
          },
          "400": {
            "$type": "color",
            "$value": "#72dbe7"
          },
          "600": {
            "$type": "color",
            "$value": "#3ca7b3"
          },
          "700": {
            "$type": "color",
            "$value": "#2c7e87"
          },
          "800": {
            "$type": "color",
            "$value": "#1b545a"
          },
          "900": {
            "$type": "color",
            "$value": "#0b2a2d"
          },
          "kingfisher": {
            "$type": "color",
            "$value": "#4dd1e0"
          }
        },
        "lagoon": {
          "100": {
            "$type": "color",
            "$value": "#e8f6fc"
          },
          "200": {
            "$type": "color",
            "$value": "#c6e9f8"
          },
          "300": {
            "$type": "color",
            "$value": "#a3dcf5"
          },
          "400": {
            "$type": "color",
            "$value": "#81cff1"
          },
          "600": {
            "$type": "color",
            "$value": "#4a9bbe"
          },
          "700": {
            "$type": "color",
            "$value": "#35748f"
          },
          "800": {
            "$type": "color",
            "$value": "#214d60"
          },
          "900": {
            "$type": "color",
            "$value": "#0c2631"
          },
          "lagoon": {
            "$type": "color",
            "$value": "#5ec2ed"
          }
        },
        "macaw": {
          "100": {
            "$type": "color",
            "$value": "#ecf3fe"
          },
          "200": {
            "$type": "color",
            "$value": "#d2e2fc"
          },
          "300": {
            "$type": "color",
            "$value": "#b8d2fa"
          },
          "400": {
            "$type": "color",
            "$value": "#9ec1f7"
          },
          "600": {
            "$type": "color",
            "$value": "#678cc7"
          },
          "700": {
            "$type": "color",
            "$value": "#4b6998"
          },
          "800": {
            "$type": "color",
            "$value": "#2e466a"
          },
          "900": {
            "$type": "color",
            "$value": "#11223b"
          },
          "macaw": {
            "$type": "color",
            "$value": "#84b0f5"
          }
        },
        "nebula": {
          "100": {
            "$type": "color",
            "$value": "#eceffd"
          },
          "200": {
            "$type": "color",
            "$value": "#d6dcfb"
          },
          "300": {
            "$type": "color",
            "$value": "#c1caf8"
          },
          "400": {
            "$type": "color",
            "$value": "#abb8f5"
          },
          "600": {
            "$type": "color",
            "$value": "#7683c7"
          },
          "700": {
            "$type": "color",
            "$value": "#56629c"
          },
          "800": {
            "$type": "color",
            "$value": "#374071"
          },
          "900": {
            "$type": "color",
            "$value": "#171e45"
          },
          "nebula": {
            "$type": "color",
            "$value": "#95a5f3"
          }
        },
        "orchid": {
          "100": {
            "$type": "color",
            "$value": "#f2f1fe"
          },
          "200": {
            "$type": "color",
            "$value": "#dedcfb"
          },
          "300": {
            "$type": "color",
            "$value": "#cbc7f8"
          },
          "400": {
            "$type": "color",
            "$value": "#b8b2f4"
          },
          "600": {
            "$type": "color",
            "$value": "#837dc6"
          },
          "700": {
            "$type": "color",
            "$value": "#625d9b"
          },
          "800": {
            "$type": "color",
            "$value": "#413d6f"
          },
          "900": {
            "$type": "color",
            "$value": "#201d44"
          },
          "orchid": {
            "$type": "color",
            "$value": "#a49df1"
          }
        }
      },
      "error": {
        "$type": "color",
        "$value": "rgba(255, 0, 0, 0.3000)"
      },
      "brand-dark": {
        "100": {
          "$type": "color",
          "$value": "#ffbddf"
        },
        "200": {
          "$type": "color",
          "$value": "#ff93ca"
        },
        "300": {
          "$type": "color",
          "$value": "#ff69b6"
        },
        "400": {
          "$type": "color",
          "$value": "#ff3fa1"
        },
        "600": {
          "$type": "color",
          "$value": "#cd016a"
        },
        "700": {
          "$type": "color",
          "$value": "#b00b5f"
        },
        "800": {
          "$type": "color",
          "$value": "#7c0040"
        },
        "900": {
          "$type": "color",
          "$value": "#53002b"
        },
        "magenta": {
          "$type": "color",
          "$value": "#f61488"
        }
      },
      "data-viz": {
        "grey": {
          "262626": {
            "$type": "color",
            "$value": "#262626"
          },
          "333333": {
            "$type": "color",
            "$value": "#333333"
          },
          "595959": {
            "$type": "color",
            "$value": "#595959"
          },
          "999999": {
            "$type": "color",
            "$value": "#999999"
          },
          "1A1A1A": {
            "$type": "color",
            "$value": "#1a1a1a"
          },
          "B3B3B3": {
            "$type": "color",
            "$value": "#b3b3b3"
          },
          "CCCCCC": {
            "$type": "color",
            "$value": "#cccccc"
          },
          "E6E6E6": {
            "$type": "color",
            "$value": "#e6e6e6"
          }
        },
        "magenta": {
          "880046": {
            "$type": "color",
            "$value": "#880046"
          },
          "B5005D": {
            "$type": "color",
            "$value": "#b5005d"
          },
          "E20074": {
            "$type": "color",
            "$value": "#e20074"
          },
          "F61488": {
            "$type": "color",
            "$value": "#f61488"
          },
          "FF3FA1": {
            "$type": "color",
            "$value": "#ff3fa1"
          },
          "FF69B6": {
            "$type": "color",
            "$value": "#ff69b6"
          },
          "EE66AC": {
            "$type": "color",
            "$value": "#ee66ac"
          },
          "F399C7": {
            "$type": "color",
            "$value": "#f399c7"
          },
          "F9CCE3": {
            "$type": "color",
            "$value": "#f9cce3"
          }
        },
        "aperitif": {
          "180601": {
            "$type": "color",
            "$value": "#180601"
          },
          "330900": {
            "$type": "color",
            "$value": "#330900"
          },
          "661300": {
            "$type": "color",
            "$value": "#661300"
          },
          "801700": {
            "$type": "color",
            "$value": "#801700"
          },
          "4C0E00": {
            "$type": "color",
            "$value": "#4c0e00"
          },
          "991C00": {
            "$type": "color",
            "$value": "#991c00"
          },
          "A81E00": {
            "$type": "color",
            "$value": "#a81e00"
          },
          "CC2400": {
            "$type": "color",
            "$value": "#cc2400"
          },
          "FF846B": {
            "$type": "color",
            "$value": "#ff846b"
          },
          "FF9780": {
            "$type": "color",
            "$value": "#ff9780"
          },
          "FFAB99": {
            "$type": "color",
            "$value": "#ffab99"
          },
          "FFD6CC": {
            "$type": "color",
            "$value": "#ffd6cc"
          },
          "FFEBE5": {
            "$type": "color",
            "$value": "#ffebe5"
          }
        },
        "basketball": {
          "381300": {
            "$type": "color",
            "$value": "#381300"
          },
          "993300": {
            "$type": "color",
            "$value": "#993300"
          },
          "802B00": {
            "$type": "color",
            "$value": "#802b00"
          },
          "1A0900": {
            "$type": "color",
            "$value": "#1a0900"
          },
          "521B00": {
            "$type": "color",
            "$value": "#521b00"
          },
          "6B2400": {
            "$type": "color",
            "$value": "#6b2400"
          },
          "AB3900": {
            "$type": "color",
            "$value": "#ab3900"
          },
          "CC4400": {
            "$type": "color",
            "$value": "#cc4400"
          },
          "FF9661": {
            "$type": "color",
            "$value": "#ff9661"
          },
          "FFA77A": {
            "$type": "color",
            "$value": "#ffa77a"
          },
          "FFB894": {
            "$type": "color",
            "$value": "#ffb894"
          },
          "FFDAC7": {
            "$type": "color",
            "$value": "#ffdac7"
          },
          "FFE9DE": {
            "$type": "color",
            "$value": "#ffe9de"
          }
        },
        "cheddar": {
          "804300": {
            "$type": "color",
            "$value": "#804300"
          },
          "995100": {
            "$type": "color",
            "$value": "#995100"
          },
          "1A0D00": {
            "$type": "color",
            "$value": "#1a0d00"
          },
          "381E00": {
            "$type": "color",
            "$value": "#381e00"
          },
          "522B00": {
            "$type": "color",
            "$value": "#522b00"
          },
          "6B3900": {
            "$type": "color",
            "$value": "#6b3900"
          },
          "AB5A00": {
            "$type": "color",
            "$value": "#ab5a00"
          },
          "C46800": {
            "$type": "color",
            "$value": "#c46800"
          },
          "FFAB4D": {
            "$type": "color",
            "$value": "#ffab4d"
          },
          "FFB766": {
            "$type": "color",
            "$value": "#ffb766"
          },
          "FFC380": {
            "$type": "color",
            "$value": "#ffc380"
          },
          "FFDBB2": {
            "$type": "color",
            "$value": "#ffdbb2"
          },
          "FFE7CC": {
            "$type": "color",
            "$value": "#ffe7cc"
          }
        },
        "dandelion": {
          "403200": {
            "$type": "color",
            "$value": "#403200"
          },
          "705800": {
            "$type": "color",
            "$value": "#705800"
          },
          "806400": {
            "$type": "color",
            "$value": "#806400"
          },
          "947400": {
            "$type": "color",
            "$value": "#947400"
          },
          "1A1400": {
            "$type": "color",
            "$value": "#1a1400"
          },
          "614C00": {
            "$type": "color",
            "$value": "#614c00"
          },
          "A68200": {
            "$type": "color",
            "$value": "#a68200"
          },
          "BF9600": {
            "$type": "color",
            "$value": "#bf9600"
          },
          "F6D046": {
            "$type": "color",
            "$value": "#f6d046"
          },
          "F7D65F": {
            "$type": "color",
            "$value": "#f7d65f"
          },
          "F8DC77": {
            "$type": "color",
            "$value": "#f8dc77"
          },
          "FBE9A7": {
            "$type": "color",
            "$value": "#fbe9a7"
          },
          "FCF1CA": {
            "$type": "color",
            "$value": "#fcf1ca"
          }
        },
        "egg": {
          "857700": {
            "$type": "color",
            "$value": "#857700"
          },
          "7A6E00": {
            "$type": "color",
            "$value": "#7a6e00"
          },
          "1F1B00": {
            "$type": "color",
            "$value": "#1f1b00"
          },
          "3D3700": {
            "$type": "color",
            "$value": "#3d3700"
          },
          "5E5500": {
            "$type": "color",
            "$value": "#5e5500"
          },
          "6B6000": {
            "$type": "color",
            "$value": "#6b6000"
          },
          "A39300": {
            "$type": "color",
            "$value": "#a39300"
          },
          "BAA700": {
            "$type": "color",
            "$value": "#baa700"
          },
          "EFDC34": {
            "$type": "color",
            "$value": "#efdc34"
          },
          "EFDE4C": {
            "$type": "color",
            "$value": "#efde4c"
          },
          "EFE167": {
            "$type": "color",
            "$value": "#efe167"
          },
          "EFE79B": {
            "$type": "color",
            "$value": "#efe79b"
          },
          "EFEABF": {
            "$type": "color",
            "$value": "#efeabf"
          }
        },
        "frog": {
          "525700": {
            "$type": "color",
            "$value": "#525700"
          },
          "616600": {
            "$type": "color",
            "$value": "#616600"
          },
          "6D7300": {
            "$type": "color",
            "$value": "#6d7300"
          },
          "181A00": {
            "$type": "color",
            "$value": "#181a00"
          },
          "3A3D00": {
            "$type": "color",
            "$value": "#3a3d00"
          },
          "7E8500": {
            "$type": "color",
            "$value": "#7e8500"
          },
          "8D9400": {
            "$type": "color",
            "$value": "#8d9400"
          },
          "A0A800": {
            "$type": "color",
            "$value": "#a0a800"
          },
          "D4DC38": {
            "$type": "color",
            "$value": "#d4dc38"
          },
          "D6DC58": {
            "$type": "color",
            "$value": "#d6dc58"
          },
          "D7DC6E": {
            "$type": "color",
            "$value": "#d7dc6e"
          },
          "D9DC9A": {
            "$type": "color",
            "$value": "#d9dc9a"
          },
          "DADCBB": {
            "$type": "color",
            "$value": "#dadcbb"
          }
        },
        "guacamole": {
          "315400": {
            "$type": "color",
            "$value": "#315400"
          },
          "467800": {
            "$type": "color",
            "$value": "#467800"
          },
          "579400": {
            "$type": "color",
            "$value": "#579400"
          },
          "121F00": {
            "$type": "color",
            "$value": "#121f00"
          },
          "243D00": {
            "$type": "color",
            "$value": "#243d00"
          },
          "3C6600": {
            "$type": "color",
            "$value": "#3c6600"
          },
          "61A600": {
            "$type": "color",
            "$value": "#61a600"
          },
          "70BF00": {
            "$type": "color",
            "$value": "#70bf00"
          },
          "A7DE59": {
            "$type": "color",
            "$value": "#a7de59"
          },
          "B0DE6F": {
            "$type": "color",
            "$value": "#b0de6f"
          },
          "B9DE85": {
            "$type": "color",
            "$value": "#b9de85"
          },
          "CCDEB2": {
            "$type": "color",
            "$value": "#ccdeb2"
          },
          "D5DEC8": {
            "$type": "color",
            "$value": "#d5dec8"
          }
        },
        "hummingbird": {
          "008510": {
            "$type": "color",
            "$value": "#008510"
          },
          "002404": {
            "$type": "color",
            "$value": "#002404"
          },
          "004708": {
            "$type": "color",
            "$value": "#004708"
          },
          "005C0B": {
            "$type": "color",
            "$value": "#005c0b"
          },
          "00700D": {
            "$type": "color",
            "$value": "#00700d"
          },
          "009E13": {
            "$type": "color",
            "$value": "#009e13"
          },
          "00B515": {
            "$type": "color",
            "$value": "#00b515"
          },
          "00CC18": {
            "$type": "color",
            "$value": "#00cc18"
          },
          "6AE278": {
            "$type": "color",
            "$value": "#6ae278"
          },
          "6CE27A": {
            "$type": "color",
            "$value": "#6ce27a"
          },
          "81E28C": {
            "$type": "color",
            "$value": "#81e28c"
          },
          "B0E2B6": {
            "$type": "color",
            "$value": "#b0e2b6"
          },
          "C7E2CA": {
            "$type": "color",
            "$value": "#c7e2ca"
          }
        },
        "iguana": {
          "008055": {
            "$type": "color",
            "$value": "#008055"
          },
          "001F14": {
            "$type": "color",
            "$value": "#001f14"
          },
          "003D29": {
            "$type": "color",
            "$value": "#003d29"
          },
          "00573A": {
            "$type": "color",
            "$value": "#00573a"
          },
          "006B47": {
            "$type": "color",
            "$value": "#006b47"
          },
          "009463": {
            "$type": "color",
            "$value": "#009463"
          },
          "00A36D": {
            "$type": "color",
            "$value": "#00a36d"
          },
          "00B87A": {
            "$type": "color",
            "$value": "#00b87a"
          },
          "5AE0B3": {
            "$type": "color",
            "$value": "#5ae0b3"
          },
          "70E0BB": {
            "$type": "color",
            "$value": "#70e0bb"
          },
          "86E0C2": {
            "$type": "color",
            "$value": "#86e0c2"
          },
          "B3E0D1": {
            "$type": "color",
            "$value": "#b3e0d1"
          },
          "CAE0D9": {
            "$type": "color",
            "$value": "#cae0d9"
          }
        },
        "jacuzzi": {
          "008075": {
            "$type": "color",
            "$value": "#008075"
          },
          "001F1C": {
            "$type": "color",
            "$value": "#001f1c"
          },
          "003D38": {
            "$type": "color",
            "$value": "#003d38"
          },
          "00574F": {
            "$type": "color",
            "$value": "#00574f"
          },
          "006B62": {
            "$type": "color",
            "$value": "#006b62"
          },
          "009487": {
            "$type": "color",
            "$value": "#009487"
          },
          "00A396": {
            "$type": "color",
            "$value": "#00a396"
          },
          "00B8A8": {
            "$type": "color",
            "$value": "#00b8a8"
          },
          "57D9CE": {
            "$type": "color",
            "$value": "#57d9ce"
          },
          "6DD9D0": {
            "$type": "color",
            "$value": "#6dd9d0"
          },
          "82D9D2": {
            "$type": "color",
            "$value": "#82d9d2"
          },
          "AED9D5": {
            "$type": "color",
            "$value": "#aed9d5"
          },
          "C3D9D7": {
            "$type": "color",
            "$value": "#c3d9d7"
          }
        },
        "kingfisher": {
          "007280": {
            "$type": "color",
            "$value": "#007280"
          },
          "001B1F": {
            "$type": "color",
            "$value": "#001b1f"
          },
          "00373D": {
            "$type": "color",
            "$value": "#00373d"
          },
          "004E57": {
            "$type": "color",
            "$value": "#004e57"
          },
          "00606B": {
            "$type": "color",
            "$value": "#00606b"
          },
          "008796": {
            "$type": "color",
            "$value": "#008796"
          },
          "0097A8": {
            "$type": "color",
            "$value": "#0097a8"
          },
          "00A9BD": {
            "$type": "color",
            "$value": "#00a9bd"
          },
          "5AD2E0": {
            "$type": "color",
            "$value": "#5ad2e0"
          },
          "70D5E0": {
            "$type": "color",
            "$value": "#70d5e0"
          },
          "86D7E0": {
            "$type": "color",
            "$value": "#86d7e0"
          },
          "B3DBE0": {
            "$type": "color",
            "$value": "#b3dbe0"
          },
          "CADEE0": {
            "$type": "color",
            "$value": "#cadee0"
          }
        },
        "lagoon": {
          "006B99": {
            "$type": "color",
            "$value": "#006b99"
          },
          "002433": {
            "$type": "color",
            "$value": "#002433"
          },
          "00354D": {
            "$type": "color",
            "$value": "#00354d"
          },
          "004B6B": {
            "$type": "color",
            "$value": "#004b6b"
          },
          "00608A": {
            "$type": "color",
            "$value": "#00608a"
          },
          "0079AD": {
            "$type": "color",
            "$value": "#0079ad"
          },
          "0088C2": {
            "$type": "color",
            "$value": "#0088c2"
          },
          "0096D6": {
            "$type": "color",
            "$value": "#0096d6"
          },
          "77C9ED": {
            "$type": "color",
            "$value": "#77c9ed"
          },
          "87CEED": {
            "$type": "color",
            "$value": "#87ceed"
          },
          "9AD4ED": {
            "$type": "color",
            "$value": "#9ad4ed"
          },
          "BEDFED": {
            "$type": "color",
            "$value": "#bedfed"
          },
          "D5E6ED": {
            "$type": "color",
            "$value": "#d5e6ed"
          }
        },
        "macaw": {
          "0041A6": {
            "$type": "color",
            "$value": "#0041a6"
          },
          "00173B": {
            "$type": "color",
            "$value": "#00173b"
          },
          "002257": {
            "$type": "color",
            "$value": "#002257"
          },
          "002D73": {
            "$type": "color",
            "$value": "#002d73"
          },
          "003991": {
            "$type": "color",
            "$value": "#003991"
          },
          "0047B8": {
            "$type": "color",
            "$value": "#0047b8"
          },
          "004FCC": {
            "$type": "color",
            "$value": "#004fcc"
          },
          "005FF5": {
            "$type": "color",
            "$value": "#005ff5"
          },
          "7BAAF5": {
            "$type": "color",
            "$value": "#7baaf5"
          },
          "8CBFF5": {
            "$type": "color",
            "$value": "#8cbff5"
          },
          "9FC1F5": {
            "$type": "color",
            "$value": "#9fc1f5"
          },
          "C4D7F5": {
            "$type": "color",
            "$value": "#c4d7f5"
          },
          "DCE6F5": {
            "$type": "color",
            "$value": "#dce6f5"
          }
        },
        "nebula": {
          "0021BF": {
            "$type": "color",
            "$value": "#0021bf"
          },
          "000B40": {
            "$type": "color",
            "$value": "#000b40"
          },
          "001166": {
            "$type": "color",
            "$value": "#001166"
          },
          "001787": {
            "$type": "color",
            "$value": "#001787"
          },
          "001CA6": {
            "$type": "color",
            "$value": "#001ca6"
          },
          "0024D6": {
            "$type": "color",
            "$value": "#0024d6"
          },
          "0029F3": {
            "$type": "color",
            "$value": "#0029f3"
          },
          "183EF3": {
            "$type": "color",
            "$value": "#183ef3"
          },
          "95A5F3": {
            "$type": "color",
            "$value": "#95a5f3"
          },
          "A8B4F3": {
            "$type": "color",
            "$value": "#a8b4f3"
          },
          "B6C1F3": {
            "$type": "color",
            "$value": "#b6c1f3"
          },
          "D3D9F3": {
            "$type": "color",
            "$value": "#d3d9f3"
          },
          "E0E3F3": {
            "$type": "color",
            "$value": "#e0e3f3"
          },
          "545FF7": {
            "$type": "color",
            "$value": "#545ff7"
          }
        },
        "orchid": {
          "300186": {
            "$type": "color",
            "$value": "#300186"
          },
          "1000BF": {
            "$type": "color",
            "$value": "#1000bf"
          },
          "040033": {
            "$type": "color",
            "$value": "#040033"
          },
          "080066": {
            "$type": "color",
            "$value": "#080066"
          },
          "0B0087": {
            "$type": "color",
            "$value": "#0b0087"
          },
          "0E00A6": {
            "$type": "color",
            "$value": "#0e00a6"
          },
          "1200D6": {
            "$type": "color",
            "$value": "#1200d6"
          },
          "1400F1": {
            "$type": "color",
            "$value": "#1400f1"
          },
          "2A18F1": {
            "$type": "color",
            "$value": "#2a18f1"
          },
          "9289F1": {
            "$type": "color",
            "$value": "#9289f1"
          },
          "9D95F1": {
            "$type": "color",
            "$value": "#9d95f1"
          },
          "A69FF1": {
            "$type": "color",
            "$value": "#a69ff1"
          },
          "C5C1F1": {
            "$type": "color",
            "$value": "#c5c1f1"
          },
          "DBD9F1": {
            "$type": "color",
            "$value": "#dbd9f1"
          },
          "4000BF": {
            "$type": "color",
            "$value": "#4000bf"
          },
          "4B00D6": {
            "$type": "color",
            "$value": "#4b00d6"
          },
          "5000F1": {
            "$type": "color",
            "$value": "#5000f1"
          },
          "7335FB": {
            "$type": "color",
            "$value": "#7335fb"
          }
        }
      }
    }
  }
}
